import script from "./MobileTransferPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileTransferPage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileTransferPage.vue?vue&type=style&index=0&id=10a78a30&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a78a30"]])

export default __exports__